import type { Campaign, Comment, Variant, FieldIssue } from './types';

export const PLACEHOLDER_CAMPAIGN: Campaign = {
  platform: 'Meta',
  quarter: 'Q1 2026',
  market: 'FR',
  businessUnit: 'Ford Model e',
  nameplate: 'Mustang Mach-E',
  buyType: 'Awareness',
  tier: 'Tier 1',
  format: 'Single Image',
  fordshareId: '12345',
};

export const PLACEHOLDER_VARIANTS: Variant[] = [
  { label: 'Variant 1', hasData: true },
  { label: 'Variant 2', hasData: true },
  { label: 'Variant 3', hasData: false },
];

export const PLACEHOLDER_FIELD_ISSUES: Record<string, FieldIssue> = {
  primary_text: { errors: ['Primary text is required'], warnings: [] },
  description:  { errors: [], warnings: ['Description is recommended but not provided'] },
};

// Dates are relative offsets so the prototype looks realistic at any time
const now = new Date();
const minsAgo = (m: number) => new Date(now.getTime() - m * 60_000).toISOString();
const daysAgo = (d: number) => new Date(now.getTime() - d * 86_400_000).toISOString();

export const PLACEHOLDER_COMMENTS: Comment[] = [
  { author: 'James K.',    initials: 'JK', date: daysAgo(3),  type: 'general',   text: 'Headline copy has been reviewed and cleared by the legal team — no changes needed.' },
  { author: 'Sarah M.',    initials: 'SM', date: daysAgo(1),  type: 'rejection',  text: 'Primary text needs to be updated — does not meet current brand guidelines.' },
  { author: 'Blair W.',    initials: 'BW', date: minsAgo(45), type: 'general',    text: 'Updated the primary text, should be good now. Legal sign-off still valid per James.' },
  { author: 'Kathrine S.', initials: 'KS', date: minsAgo(12), type: 'approval',   text: '', approvalNote: 'Looks great, approved for Q1 rollout.' },
];

export const DUMMY_CAROUSEL_ITEMS = [
  { imageUrl: '', headline: 'Headline placeholder\u2026' },
  { imageUrl: '', headline: 'Headline placeholder\u2026' },
  { imageUrl: '', headline: 'Headline placeholder\u2026' },
];
